export default {
  reloadControllerConfig: 'Controller Konfiguration neuladen',
};
